export const stringifyPesel = (pesel: string | number): string => '' + pesel;
